import { useTranslation } from "react-i18next";
import { FolderInput, Trash2 } from "lucide-react";
import { Button } from "components/common/Button";
import { Select } from "components/common/Select";
import { GridSelectionChip } from "../GridSelectionChip";
import type { GridReviewToolbarProps } from "./types";

export const GridReviewToolbar = ({
  selectedCount,
  groupOptions,
  currentGroupLabel,
  moveTargetGroupLabel,
  isBusy,
  onMoveTargetGroupLabelChange,
  onClearSelection,
  onMoveSelected,
  onDeleteSelected,
}: GridReviewToolbarProps) => {
  const { t } = useTranslation();

  const hasSelection = selectedCount > 0;
  const trimmedMoveTargetGroupLabel = moveTargetGroupLabel.trim();
  const canMove =
    hasSelection &&
    trimmedMoveTargetGroupLabel !== "" &&
    trimmedMoveTargetGroupLabel !== currentGroupLabel &&
    !isBusy;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-gray-200 px-4 py-2 sm:px-6">
      <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">
        <Select
          value={moveTargetGroupLabel}
          onChange={onMoveTargetGroupLabelChange}
          options={groupOptions}
          autoFilter
          placeholder={t("smartSurveyor.gridReview.moveToGroupPlaceholder")}
          className="w-full sm:w-80"
          disabled={isBusy}
        />
        <Button
          variant="primary"
          size="sm"
          onClick={onMoveSelected}
          disabled={!canMove}
          startAdornment={<FolderInput size={14} />}
        >
          {t("smartSurveyor.gridReview.moveSelected")}
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={onDeleteSelected}
          disabled={!hasSelection || isBusy}
          startAdornment={<Trash2 size={14} />}
        >
          {t("smartSurveyor.gridReview.deleteSelected")}
        </Button>
      </div>
      <GridSelectionChip
        selectedCount={selectedCount}
        isBusy={isBusy}
        onClearSelection={onClearSelection}
      />
    </div>
  );
};
